// Configuração para projeto de Distribuidora de Gás

export const GAS_DISTRIBUTOR_INITIAL_STATE = {
  // Etapa 5: Produtos
  selectedProducts: [],
  productPrices: {}, // { productId: { preco_padrao, desconto_vip, desconto_recorrente, desconto_novo } }
  
  // Etapa 6: Configuração da Empresa
  telefoneEmpresa: '',
  enderecoBase: '',
  horariosFunc: {
    segunda: '08:00-18:00',
    terca: '08:00-18:00',
    quarta: '08:00-18:00',
    quinta: '08:00-18:00',
    sexta: '08:00-18:00',
    sabado: '08:00-12:00',
    domingo: ''
  },
  diasEntrega: ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'],
  
  // Áreas de Cobertura
  areasCoberturaList: [
    { id: 1, bairro: '', taxaEntrega: 0, tempoMedio: 60 }
  ],
  
  // Formas de Pagamento
  formasPagamento: ['dinheiro', 'pix'],
  
  // Políticas
  politicaEntrega: '',
  politicaCancelamento: '',
  
  // Imagem para Primeiro Atendimento
  imagemPrimeiroAtendimento: null,
  imagemPrimeiroAtendimentoPreview: null,
  
  // Grupo WhatsApp (configurado na etapa 4)
  grupoWhatsappId: '',
  grupoWhatsappNome: '',
  numerosEntregadores: [{ id: 1, nome: '', numero: '' }],
  
  // Agente (configurado na etapa 4)
  agenteDraft: {
    name: 'Atendente - Distribuição',
    prompt: ''
  }
};

export const GAS_DISTRIBUTOR_LISTS = [
  {
    name: 'Clientes Novos',
    color: '#3b82f6',
    icon: 'person_add',
    description: 'Novos clientes que entraram em contato',
    order: 0
  },
  {
    name: 'Cliente em Atendimento',
    color: '#f59e0b',
    icon: 'support_agent',
    description: 'Agente conversando com cliente',
    order: 1
  },
  {
    name: 'Entrega Imediata',
    color: '#10b981',
    icon: 'local_shipping',
    description: 'Pronto para entregar hoje',
    order: 2,
    metadata: {
      group_notification: {
        enabled: true,
        message: '',
        buttons_enabled: true,
        notify_client: false,
        client_message: ''
      }
    }
  },
  {
    name: 'Entrega Agendada',
    color: '#8b5cf6',
    icon: 'schedule',
    description: 'Entrega marcada para data/hora específica',
    order: 3,
    metadata: {
      group_notification: {
        enabled: true,
        message: '',
        buttons_enabled: true,
        notify_client: false,
        client_message: ''
      }
    }
  },
  {
    name: 'Em Entrega',
    color: '#06b6d4',
    icon: 'directions_car',
    description: 'Entregador saiu com o produto',
    order: 4,
    metadata: {
      delivery_notification: {
        enabled: true,
        message: '',
        notify_client: true,
        client_message: ''
      }
    }
  },
  {
    name: 'Entregue',
    color: '#22c55e',
    icon: 'check_circle',
    description: 'Produto entregue com sucesso',
    order: 5,
    metadata: {
      delivered_notification: {
        enabled: true,
        message: '',
        notify_client: true,
        client_message: ''
      }
    }
  },
  {
    name: 'Distribuição Follow-up',
    color: '#94a3b8',
    icon: 'assignment',
    description: 'Gestão de acompanhamento de clientes',
    order: 6
  },
  {
    name: 'Follow-up 1',
    color: '#ec4899',
    icon: 'schedule',
    description: 'Acompanhamento após 7 dias',
    order: 7
  },
  {
    name: 'Follow-up 2',
    color: '#f472b6',
    icon: 'schedule',
    description: 'Acompanhamento após 30 dias',
    order: 8
  },
  {
    name: 'Cliente Inativo',
    color: '#6b7280',
    icon: 'person_off',
    description: 'Sem compras há 60+ dias',
    order: 9
  },
  {
    name: 'Cancelado',
    color: '#ef4444',
    icon: 'cancel',
    description: 'Cliente não quis fazer pedido',
    order: 10
  }
];

export const GAS_DISTRIBUTOR_AUTOMATIONS = {
  'Em Atendimento': {
    formulario: true,
    campos: [
      { name: 'tipo_cliente', label: 'Tipo de Cliente', type: 'select', options: ['novo', 'existente'] },
      { name: 'endereco', label: 'Endereço', type: 'text' },
      { name: 'produto', label: 'Produto Desejado', type: 'text' },
      { name: 'quantidade', label: 'Quantidade', type: 'number' },
      { name: 'forma_pagamento', label: 'Forma de Pagamento', type: 'select', options: ['dinheiro', 'pix', 'cartao'] },
      { name: 'horario', label: 'Horário Preferido', type: 'select', options: ['manhã', 'tarde', 'noite'] },
      { name: 'observacoes', label: 'Observações', type: 'textarea' }
    ],
    mensagem: 'Estamos processando seu pedido...'
  },
  'Entrega Imediata': {
    enviarGrupo: true,
    mensagemGrupo: '🚚 NOVO PEDIDO\nCliente: {cliente}\nProduto: {produto}\nEndereço: {endereco}\nLocalização: {latitude}, {longitude}',
    mensagemCliente: 'Seu pedido foi confirmado! Saiu para entrega agora! 🚗'
  },
  'Entrega Agendada': {
    enviarGrupo: true,
    lembrete: true,
    tempoAviso: 30, // minutos antes
    mensagemGrupo: '📅 Entrega agendada para {data} {hora}\nCliente: {cliente}\nEndereço: {endereco}',
    mensagemCliente: 'Sua entrega está agendada para {data} às {hora}'
  },
  'Em Entrega': {
    mensagemCliente: 'Saiu para entrega! 🚗',
    notificarGrupo: true
  },
  'Entregue': {
    followup: true,
    diasFollowup: 7,
    mensagem: 'Tudo certo com a entrega? Precisa de mais gás?'
  }
};
